import { FC } from 'react';
import styles from './DeleteConfirmationModal.module.css';
import { DeleteConfirmationModalProps } from './DeleteConfirmationModal.types';
import Button from '../../../../../../components/Button/Button';
import { useDeleteAvailablePrice } from '../../../../../../services/bundles/bundles.service';
import { showToast } from '../../../../../../components/Toast/Toast';
import { ToastTypes } from '../../../../../../components/Toast/Toast.types';
import { ButtonVariants } from '../../../../../../components/Button/Button.types';
import Modal from '../../../../../../components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';

const DeleteConfirmationModal: FC<DeleteConfirmationModalProps> = ({
  bundleId,
  price,
  prices,
  isOpen,
  availablePrices,
  onClose,
  removePrice,
  setPrices,
  postDeleteBundleData,
}) => {
  const { t } = useTranslation();
  const { mutate: deleteAvailablePrice, isLoading: deleteAvailablePriceIsLoading } = useDeleteAvailablePrice();
  const queryClient = useQueryClient();

  const handleDeleteSuccess = () => {
    if (prices.includes(parseFloat(price))) {
      const currentPrices: number[] = [];
      if (availablePrices) {
        for (const stringPrice of availablePrices) {
          const stringPriceToNum = parseFloat(stringPrice);
          if (!Number.isNaN(stringPriceToNum) && stringPriceToNum !== parseFloat(price))
            currentPrices.push(parseFloat(stringPriceToNum.toFixed(2)));
        }
      }
      setPrices(currentPrices);
    }
    removePrice(Number(price));
    postDeleteBundleData();
    onClose();
    showToast({
      toastType: ToastTypes.Success,
      label: t('editBundle.prices.priceRemovedSuccessfully'),
      id: 'deleteAvailablePriceSuccess',
    });
    queryClient.invalidateQueries(['bundle', bundleId]);
  };
  const handleDeleteError = () => {
    showToast({
      toastType: ToastTypes.Error,
      label: t('error.deletingPrice', { price }),
      id: 'priceDeleteError',
    });
  };
  const handleDelete = () => {
    deleteAvailablePrice({ bundleId, price }, { onSuccess: handleDeleteSuccess, onError: handleDeleteError });
  };
  return (
    <Modal
      className={styles.deleteModal}
      isOpen={isOpen}
      onClose={onClose}
      showTitleDivider
      headerContent={t('editBundle.prices.removePricePoint?', { price })}
      footerContent={
        <div className={styles.modalButtons}>
          <Button variant={ButtonVariants.Secondary} onClick={onClose} type="button">
            {t('common.cancel')}
          </Button>
          <Button onClick={handleDelete} type="button" isLoading={deleteAvailablePriceIsLoading}>
            {t('common.confirm')}
          </Button>
        </div>
      }
    />
  );
};
export default DeleteConfirmationModal;
